﻿
export enum LogistikanbieterEnum {
  Abholung = 0,
  DPD = 10,
  DHL = 20,
  Post = 40,
}
